import React from "react";
import { Row, Col } from "antd";
import { formatMoneyValue } from "utils/utils";
import DBS_PAY_NOW_QR from "./DBS_PAYNOW_QR.png";
import OCBC_PAY_NOW_QR from "./OCBC_PAYNOW_QR.jpg";

import "./DbsPayNowInstructionsPanel.css";

export default class DbsPayNowInstructionsPanel extends React.Component {
  render() {
    return (
      <>
        <p>Use the instructions below to make your "PAYNOW" payment. Your Reference ID : <b>{this.props.currentCustomer.referenceNumber}</b></p>
        <span className="bp-notice">
          We will only process your order if the payment to Brdgx is from a
          same-name account.
        </span>
        <div className="bp-inner-panel bp-inner-padding-lg">
          <Row gutter={16}>
            <Col md={11}>
              <div className={"rq-code-block"}>
                <div className={"inner"}>
                  <span>Scan this QR code to make payment. <b>{formatMoneyValue(this.props.payment.sourceValue)}</b></span>
                  <img
                    className="dbs-paynow-qrcode"
                    src={OCBC_PAY_NOW_QR}
                    alt={"qrcode"}
                  />
                  <span>Please input <u><b>{this.props.currentCustomer.referenceNumber}</b></u> as payment reference during the payment.</span>
                </div>
                
              </div>
            </Col>
            <Col md={2}>
              <div className={"or-copy"}>OR</div>
            </Col>
            <Col md={11}>
              <div className={"uen-number-block"}>
                <span>Select UEN and type the below : </span>
                <div className={"code-outline"}>201625099RSGD</div>
              </div>
            </Col> 
          </Row>
        </div>
      </>
    );
  }
}
